
import PlotModel from '../PlotModel';
import PropertyDescriptor from '../../../designer/utils/PropertyDescriptor';
import EllipseSettingsProperty from './EllipseSettingsProperty';

export default class Model extends PlotModel {

    settings = new PropertyDescriptor(new EllipseSettingsProperty(), "设置", "高级", "propertygrid", "#anticon-profile-setting", {
        gallery: "外观",
        valueTemplate: EllipseSettingsProperty,
    });

    constructor(opts = {}) {
        super();

        this.defineAllProperties();

        for (var p in opts) {
            this[p] = opts[p];
        }
    }

    getType() {
        return "PlotEllipseModel";
    }

    toStyle() {
        return this.settings.toStyle();
    }
}
